module.exports = __webpack_public_path__ + "static/media/service1.fd13ffc3.png";